import { Component, OnInit } from "@angular/core";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { UserManagementService } from "../../../../core/services/user-management.service";
import { UserRole } from "../../../../shared/enums/userRoles.enum";
import { TableModule } from "primeng/table";
import { ModalStackerComponent } from "../../../../shared/components/modal-stacker/modal-stacker.component";
import { ProductSummaryComponent } from "../product-summary/product-summary.component";
import { ReleasedProduct } from "../../../../core/models/shared/releaseProduct";
import { ItemsSecurity } from "../../../../core/models/samplePO/details/itemsSecurity";
import { SamplepoListingService } from "../../../../core/services/samplepo-listing.service";
import { VariantsListingComponent } from "../variants-listing/variants-listing.component";
import { CommonModule } from "@angular/common";

import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { InputTextModule } from "primeng/inputtext";

@UntilDestroy()
@Component({
  selector: "jni-products-listing",
  templateUrl: "./products-listing.component.html",
  styleUrls: ["./products-listing.component.scss"],
  imports: [
    TableModule,
    ModalStackerComponent,
    ProductSummaryComponent,
    VariantsListingComponent,
    CommonModule,
    ButtonModule,
    CardModule,
    InputTextModule,
  ],
})
export class ProductsListingComponent implements OnInit {
  filterProductsListing: ReleasedProduct[] = [];
  productsListing: ReleasedProduct[] = [];
  selectedProductsListing!: ReleasedProduct;
  productDetailModal = false;
  variantsListingModal = false;
  modalReleasedStoreProducts: ReleasedProduct = {} as ReleasedProduct;
  selectedVariantItemNumber = "";
  productSecurity = {} as ItemsSecurity;
  userRole = 0;
  enumUserRole = UserRole;

  constructor(
    private _samplepoListingService: SamplepoListingService,
    private _loginService: UserManagementService
  ) {}

  ngOnInit(): void {
    this.getUserProfile();
    this.getAllReleaseProduct();
    this.supportRoles();
  }

  getAllReleaseProduct() {
    this._samplepoListingService
      .getAllCategory()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.productsListing = res.data;
          this.productsListing.forEach(x => {
            if (!x.nameD365) {
              x.nameD365 = x.itemNumberD365;
            }
          });

          this.filterProductsListing = [...this.productsListing];

          this.filterProducts();
        },
      });
  }

  supportRoles() {
    this._samplepoListingService
      .supportRoles()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.productSecurity = res.data;
          this.filterProducts();
        },
      });
  }

  getUserProfile() {
    this._loginService
      .validateLogin()
      .pipe()
      .subscribe(res => {
        this.userRole = res.data.userRoleId;
        this.filterProducts();
      });
  }

  filterProducts() {
    if (this.userRole !== this.enumUserRole.Admin) {
      this.filterProductsListing = [];
      if (this.productSecurity && Object.keys(this.productSecurity).length) {
        if (this.productSecurity.redHat) {
          this.filterProductsListing = this.productsListing.filter(
            x => x.storeD365 == "REDHAT"
          );
        }

        if (this.productSecurity.boozAllen) {
          const boozProducts = this.productsListing.filter(
            x => x.storeD365 == "BOOZALLEN"
          );
          this.filterProductsListing.push(...boozProducts);
        }
      }
    }
  }

  redirectToProductSummary(item: ReleasedProduct) {
    if (item) {
      this.modalReleasedStoreProducts = item;
      this.productDetailModal = true;
    }
  }

  showVariants() {
    if (this.selectedProductsListing?.itemNumberD365) {
      this.selectedVariantItemNumber =
        this.selectedProductsListing?.itemNumberD365;
      this.variantsListingModal = true;
    }
  }

  //closing Modal
  closeModalForProductDetail() {
    this.productDetailModal = false;
  }

  closeModalForVariantsListing() {
    this.variantsListingModal = false;
  }
}
